import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { LoginPage } from './pages/Login';
import { DashboardLayout, DashboardHome } from './pages/Dashboard';
import { ScentMatchPage } from './pages/ScentMatch';
import { CatalogPage } from './pages/Catalog';
import { AnalyticsPage } from './pages/Analytics';
import { SettingsPage } from './pages/Settings';
import { KioskPage } from './pages/Kiosk';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public: Login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Public: Kiosk for customers */}
            <Route path="/k/:clientId" element={<KioskPage />} />
            <Route path="/kiosk/:clientId" element={<KioskPage />} />

            {/* Protected: Client Dashboard */}
            <Route path="/:clientId" element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="scentmatch" element={<ScentMatchPage />} />
              <Route path="catalog" element={<CatalogPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
